// extracted by mini-css-extract-plugin
export default {"sub-row":"SelectionModalExpandedRow_sub-row__xn6nX","scores":"SelectionModalExpandedRow_scores__IjA3U"};